import React from "react";
import { outerLink } from "../../utils/functions";

const awards = [
  {
    tag: "Class 34",
    image: require("../../assets/images/award-3.png"),
    link: "https://vault.alchemistaccelerator.com/companies/public/datazip-technologies",
  },
  {
    tag: "2022 Cohort Finalists",
    image: require("../../assets/images/award-1.png"),
    link: "https://events22-23.yourstory.com/aws-saas-central?fbclid=IwAR11ZpiscVO5S2hsfiXq3BbCAujM6G7wziIUDGdmemrTvz3opP_8elaTrFk#Cohorts-2022",
  },
  {
    tag: "Winners - Wild Card",
    image: require("../../assets/images/award-2.png"),
    link: "https://www.agorize.com/en/challenges/tech-week-2022/pages/winners",
  },
  {
    tag: "Backed by",
    image: require("../../assets/images/award-4.png"),
    link: "https://www.firstcheque.vc/portfolio",
  },
];

const AwardCard = ({ award: { tag, image, link } }) => {
  return (
    <div className="award-card reveal-from-bottom">
      <div className="tag text__tag">{tag}</div>
      <img src={image} alt="awards img" />
      <button className="button__main" onClick={() => outerLink(link)}>
        Read More{" "}
        <img
          src={require("../../assets/images/long-arrow-right.svg")}
          alt="arrow right"
        />
      </button>
    </div>
  );
};

const Awards = () => {
  return (
    <div className="awards">
        <div className="awards__heading text__heading ta-c reveal-from-top">
          Awards & Recognitions
        </div>
        <div className="award__content">
          {awards.map((award, index) => {
            return <AwardCard award={award} key={index} />;
          })}
        </div>
    </div>
  );
};

export default Awards;
